"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.historicClaimData = exports.stepBack = exports.readERXLog = exports.setReverse = exports.runPendingClaims = exports.getqueue = exports.deleteQueue = exports.updateQueue = exports.readQueueRow = exports.readQueue = exports.addQueue = exports.saveCounsel = exports.savePDF = exports.savePDFToServer = exports.getDataForPrintLabelDrug = exports.printLabels = exports.cancelRefillClaim = exports.delayRefillClaim = exports.updateClaimDispenseScan = exports.updateClaim = exports.refillClaim = exports.retryClaim = exports.readupdatedclaim = exports.readClaim = exports.getclaimid = exports.listClaims = exports.listclaimndcmonographs = exports.listprescribedclaims = exports.listintentclaims = exports.count = exports.undoDispense = exports.updatestatusaspaid = exports.updateOrder = exports.signatureBypass = exports.dispense = exports.cancelintentclaim = exports.read = exports.listClaimsInterval = exports.listwithindaterange = exports.listBulkOrders = exports.pendingPayablelist = exports.list = exports.createOrder = exports.submit = exports.parseColumnsHeader = exports.updateProvider = exports.buildpatientschedule = exports.parseMappedSchedule = exports.parse = exports.updateAuditStatus = exports.updateSignatures = exports.updatePrescribe = exports.loadPrescribe = exports.readTransactionData = exports.loadReadyToDispense = exports.listerxdatafield = void 0;
const endpoint_1 = require("api/endpoint");
const permissions_1 = require("shared/permissions");
exports.listerxdatafield = endpoint_1.createEndpoint()({
    method: "get",
    path: "order/listerxdatafield",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.loadReadyToDispense = endpoint_1.createEndpoint()({
    method: "get",
    path: "order/load-ready-to-dispense",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_CREATE
});
exports.readTransactionData = endpoint_1.createEndpoint()({
    method: "get",
    path: "order/transaction-data",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_CREATE
});
exports.loadPrescribe = endpoint_1.createEndpoint()({
    method: "get",
    path: "order/load-prescribe",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_CREATE
});
exports.updatePrescribe = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/update-prescribe",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_CREATE
});
exports.updateSignatures = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/update-signatures",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_CREATE
});
exports.updateAuditStatus = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/update-audit-status",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_CREATE
});
exports.parse = endpoint_1.createEndpoint()({
    formData: true,
    method: "post",
    path: "order/parse",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_CREATE
});
exports.parseMappedSchedule = endpoint_1.createEndpoint()({
    formData: true,
    method: "post",
    path: "order/parseMappedSchedule",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_CREATE
});
// export const buildpatientschedule = createEndpoint<
//   never,
//   { orders: Partial<ISubmission>[] }
// >()({
//   permissions: PERMISSIONS.DISPENSIFY_ORDER_CREATE,
//   method: 'get',
//   tokens: { patientId: 'number.required', siteId: 'number.required' },
//   path: 'order/buildpatientschedule',
// });
exports.buildpatientschedule = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/buildpatientschedule",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_CREATE
});
exports.updateProvider = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/updateprovider",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_CREATE
});
exports.parseColumnsHeader = endpoint_1.createEndpoint()({
    formData: true,
    method: "post",
    path: "order/parseColumnsHeader",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_CREATE
});
exports.submit = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/submit",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_CREATE
});
exports.createOrder = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/create",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_CREATE
});
// C-097 Claims
// export const list = createEndpoint<never, { orders: IOrder[] }>()({
exports.list = endpoint_1.createEndpoint()({
    method: "get",
    path: "order/list",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_READ
    // query: {
    //   clickedElement?: string;
    //   count: number;
    //   order?: 'ASC' | 'DESC';
    //   search?: string;
    //   searchDate?: string;
    //   showCompleted?: string;
    //   sort?: string;
    //   start: number;
    //   siteId?: number;
    // };
});
//D-002_new
exports.pendingPayablelist = endpoint_1.createEndpoint()({
    method: "get",
    path: "order/pendingPayablelist",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_READ
});
exports.listBulkOrders = endpoint_1.createEndpoint()({
    method: "get",
    path: "order/listBulkOrders",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_READ
});
exports.listwithindaterange = endpoint_1.createEndpoint()({
    method: "get",
    path: "order/listwithindaterange",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
/**
 * @tkay
 */
exports.listClaimsInterval = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/listclaimsinterval",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_READ
});
exports.read = endpoint_1.createEndpoint()({
    method: "get",
    path: "order/read",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_READ,
    tokens: { id: "number.required" }
});
exports.cancelintentclaim = endpoint_1.createEndpoint()({
    method: "put",
    path: "order/cancelintentclaim",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_DISPENSE
});
exports.dispense = endpoint_1.createEndpoint()({
    method: "put",
    path: "order/dispense",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_DISPENSE
});
// C-108.7
exports.signatureBypass = endpoint_1.createEndpoint()({
    method: "put",
    path: "order/signatureBypass",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_DISPENSE
});
exports.updateOrder = endpoint_1.createEndpoint()({
    method: "put",
    path: "order/update",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_CREATE
});
exports.updatestatusaspaid = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/updatestatusaspaid",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.undoDispense = endpoint_1.createEndpoint()({
    method: "put",
    path: "order/undoDispense",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_DISPENSE
});
exports.count = endpoint_1.createEndpoint()({
    method: "get",
    path: "order/count",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_READ
});
exports.listintentclaims = endpoint_1.createEndpoint()({
    method: "get",
    path: "order/listintentclaims",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_READ
});
exports.listprescribedclaims = endpoint_1.createEndpoint()({
    method: "get",
    path: "order/listprescribedclaims",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_READ
});
exports.listclaimndcmonographs = endpoint_1.createEndpoint()({
    method: "put",
    path: "order/listclaimndcmonographs",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.listClaims = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/claims",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_READ,
    tokens: { id: "number.required" }
});
exports.getclaimid = endpoint_1.createEndpoint()({
    method: "get",
    path: "claim/getclaimid",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_READ
});
exports.readClaim = endpoint_1.createEndpoint()({
    method: "get",
    path: "claim/read",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_READ,
    tokens: { id: "number.required" }
});
exports.readupdatedclaim = endpoint_1.createEndpoint()({
    method: "get",
    path: "claim/readupdatedclaim",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_READ,
    tokens: { id: "number.required" }
});
exports.retryClaim = endpoint_1.createEndpoint()({
    method: "put",
    path: "claim/retry",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_RETRY,
    tokens: { id: "number.required" }
});
exports.refillClaim = endpoint_1.createEndpoint()({
    method: "put",
    path: "claim/refill",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_REFILL,
    tokens: { id: "number.required" }
});
exports.updateClaim = endpoint_1.createEndpoint()({
    method: "put",
    path: "claim/update",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_REFILL // Where is the claim path!?
});
exports.updateClaimDispenseScan = endpoint_1.createEndpoint()({
    method: "put",
    path: "claim/updateClaimDispense",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_REFILL // Where is the claim path!?
});
exports.delayRefillClaim = endpoint_1.createEndpoint()({
    method: "put",
    path: "claim/delay",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_REFILL,
    tokens: { id: "number.required" }
});
exports.cancelRefillClaim = endpoint_1.createEndpoint()({
    method: "put",
    path: "claim/cancel",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_REFILL,
    tokens: { id: "number.required" }
});
exports.printLabels = endpoint_1.createEndpoint()({
    method: "get",
    path: "order/printLabels",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_DISPENSE
});
exports.getDataForPrintLabelDrug = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/getDataForPrintLabelDrug",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_READ
});
exports.savePDFToServer = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/savePDFToServer",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_DISPENSE
});
exports.savePDF = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/savePDF",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_DISPENSE
});
exports.saveCounsel = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/saveCounsel",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_DISPENSE
});
exports.addQueue = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/addQueue",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_DISPENSE
});
// C-097 Queued Appointments
exports.readQueue = endpoint_1.createEndpoint()({
    // export const readQueue = createEndpoint<never, { result: any }>()({
    method: "get",
    path: "order/readQueue",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_DISPENSE
});
exports.readQueueRow = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/readQueueRow",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_DISPENSE
});
exports.updateQueue = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/updateQueue",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_DISPENSE
});
exports.deleteQueue = endpoint_1.createEndpoint()({
    method: "post",
    path: "order/deleteQueue",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_DISPENSE
});
exports.getqueue = endpoint_1.createEndpoint()({
    method: "get",
    path: "claims/get-queue-count",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.runPendingClaims = endpoint_1.createEndpoint()({
    method: "post",
    path: "claims/run-pending-claims",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.setReverse = endpoint_1.createEndpoint()({
    method: "post",
    path: "claims/set-reverse",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.readERXLog = endpoint_1.createEndpoint()({
    method: "get",
    path: "claim/read-erx-log",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_READ
});
exports.stepBack = endpoint_1.createEndpoint()({
    method: "post",
    path: "claim/step-back",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_DISPENSE
});
exports.historicClaimData = endpoint_1.createEndpoint()({
    method: "post",
    path: "claim/historic-claim-data",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_DISPENSE
});



//////////////////
// WEBPACK FOOTER
// ./src/api/order/order-client.ts
// module id = 991
// module chunks = 0 1 2